<template>
  <v-carousel
    cycle
    height="30vh" 
    hide-delimiter-background
    show-arrows-on-hover hide-delimiters
  >
    <v-carousel-item
      v-for="(slide, i) in slides"
      :key="i"
      :src="slide.src"
      reverse-transition="fade-transition"
      transition="fade-transition"
    > 
    </v-carousel-item>
  </v-carousel>
</template>

<script>
  export default {
      name: 'HomePage',
    data () {
      return {
        colors: [
          'indigo',
          'warning',
          'pink darken-2',
          'red lighten-1',
          'deep-purple accent-4',
        ],
        slides: [
          {
            id:1,
            src: require('@/assets/album/1.jpg')
          },
          {
            id:2,
            src: require('@/assets/album/2.jpg')
          },
          {
            id:3,
            src: require('@/assets/album/3.jpg')
          }, {
            id:4,
            src: require('@/assets/album/4.jpg')
          }, {
            id:5,
            src: require('@/assets/album/5.jpg')
          }, {
            id:6,
            src: require('@/assets/album/6.jpg')
          }, {
            id:7,
            src: require('@/assets/album/7.jpg')
          }, {
            id:8,
            src: require('@/assets/album/8.jpg')
          }, {
            id:9,
            src: require('@/assets/album/9.jpg')
          }, {
            id:10,
            src: require('@/assets/album/10.jpg')
          }, {
            id:11,
            src: require('@/assets/album/11.jpg')
          }, {
            id:12,
            src: require('@/assets/album/12.jpg')
          }, {
            id:13,
            src: require('@/assets/album/13.jpg')
          }, 
        ],
      }
    },
  }
</script>